var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Logo", {
    staticClass: "logo__container--map",
    attrs: {
      show_custom: !_vm.is_pub,
      custom_logo: _vm.custom_logo,
      color: "White",
      cwa_logo_src:
        "/static/UIUX/images/header/" + _vm.logo_file_name + "_White_web@2x.png"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }